export default "__VITE_ASSET__75475e1d__"